import { FC } from 'react';
import { observer } from 'mobx-react-lite';

import { store } from 'store';

import * as S from './Loading.styles';

interface LoadingProps {
  hidden?: boolean;
}

export const Loading: FC<LoadingProps> = observer(({ hidden = false }) => {
  const {
    loadingStatus: status,
    loadingProgress: progress,
    loadingCount: count,
  } = store.galaxyStore;

  return (
    <S.Container $hidden={hidden}>
      <S.Text>INITIALIZING POLYMARKET GALAXY</S.Text>
      <S.Status>{status || 'Connecting to API...'}</S.Status>
      <S.ProgressContainer>
        <S.ProgressBar style={{ width: `${progress ?? 0}%` }} />
      </S.ProgressContainer>
      {count && <S.Count>{count}</S.Count>}
    </S.Container>
  );
});
